import { useServiceCentersAttributes } from "shared/api/serviceCenters/hooks";
import { useAttributesContext } from "shared/contexts/AttributesContext";
import { ContextProviderName } from "shared/contexts/types";
import {
  GENERIC_FILTER,
  SERVICE_CENTERS_GENERIC_FILTER,
} from "shared/filterDefinitions";

import { UseSchema } from "./types";
import {
  getAttributeMap,
  getDisplayLabelFunction,
  getFilterFunction,
  getSchemaEntryFunction,
  getSchemaForAccessorFunction,
  getSchemaFromAttributes,
} from "./utils/schema-utils";

const useServiceCentersSchema = (accessorsToHide: string[] = []): UseSchema => {
  const { data: attributes } = useServiceCentersAttributes({});
  const attributeMap = getAttributeMap(attributes);

  const getDisplayLabel = getDisplayLabelFunction(attributeMap);

  const getFilter = getFilterFunction(
    SERVICE_CENTERS_GENERIC_FILTER,
    attributeMap
  );

  const getSchemaEntry = getSchemaEntryFunction(getFilter, attributeMap);

  const schema = getSchemaFromAttributes(
    attributes,
    getSchemaEntry,
    undefined,
    undefined,
    accessorsToHide
  );

  const getSchemaForAccessor = getSchemaForAccessorFunction(schema);

  return {
    schema,
    getDisplayLabel,
    attributeMap,
    attributes,
    getSchemaEntry,
    getSchemaForAccessor,
    attributeAccessors: schema.map(
      ({ accessor, filter }) => filter?.fieldName || accessor
    ),
  };
};

const V2_VALUES_ENDPOINT = "v2/serviceCenters";

const useServiceCentersSchemaV2 = (
  accessorsToHide: string[] = []
): UseSchema => {
  const { attributes } = useAttributesContext(
    ContextProviderName.ServiceCenterV2
  );
  const attributeMap = getAttributeMap(attributes);

  const getDisplayLabel = getDisplayLabelFunction(attributeMap);

  const getFilter = getFilterFunction(
    GENERIC_FILTER,
    attributeMap,
    V2_VALUES_ENDPOINT
  );

  const getSchemaEntry = getSchemaEntryFunction(getFilter, attributeMap);

  const schema = getSchemaFromAttributes(
    attributes,
    getSchemaEntry,
    undefined,
    undefined,
    accessorsToHide
  );

  const getSchemaForAccessor = getSchemaForAccessorFunction(schema);

  return {
    schema,
    getDisplayLabel,
    attributeMap,
    attributes,
    getSchemaEntry,
    getSchemaForAccessor,
    attributeAccessors: schema.map(
      ({ accessor, filter }) => filter?.fieldName || accessor
    ),
  };
};

export { useServiceCentersSchemaV2 };
export default useServiceCentersSchema;
